/* hugify-pdp.js
 * Productpagina verbeteringen
 * - Cart bubble pulse bij toevoegen
 * - Scrolling images links fix (CSS fallback)
 */

(function() {
  'use strict';

  // --------------------------------------------------------
  // 1. CART BUBBLE PULSE
  // Luistert naar cart:refresh pubsub events van Dawn
  // en voegt een CSS klasse toe voor de pulse animatie.
  // --------------------------------------------------------
  function initCartBubblePulse() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    // Dawn pubsub
    if (typeof subscribe !== 'undefined') {
      subscribe('cart:refresh', function() {
        bubble.classList.add('hugify-cart-updated');
        setTimeout(function() {
          bubble.classList.remove('hugify-cart-updated');
        }, 600);
      });
    }
  }

  // --------------------------------------------------------
  // 2. INITIALISATIE
  // --------------------------------------------------------
  function init() {
    initCartBubblePulse();
  }

  // Start na DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();